import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import PrivateLayout from './layouts/PrivateLayout';
import PrivateRoute from './routes/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Workflows from './pages/Workflows';
import UsersPage from './pages/UsersPage';

const LogsPage = lazy(() => import('./pages/LogsPage'));
const ConversationsPage = lazy(() => import('./pages/ConversationsPage'));
const CachePage = lazy(() => import('./pages/CachePage'));
const SystemHealthPage = lazy(() => import('./pages/SystemHealthPage'));
const VectorDbPage = lazy(() => import('./pages/VectorDbPage'));

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <PrivateRoute>
            <PrivateLayout />
          </PrivateRoute>
        }>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="workflows" element={<Workflows />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="logs" element={
            <Suspense fallback={<div className="p-4">Loading...</div>}>
              <LogsPage />
            </Suspense>
          } />
          <Route path="conversations" element={
            <Suspense fallback={<div className="p-4">Loading...</div>}>
              <ConversationsPage />
            </Suspense>
          } />
          <Route path="cache" element={
            <Suspense fallback={<div className="p-4">Loading...</div>}>
              <CachePage />
            </Suspense>
          } />
          <Route path="system" element={
            <Suspense fallback={<div className="p-4">Loading...</div>}>
              <SystemHealthPage />
            </Suspense>
          } />
          <Route path="vectordb" element={
            <Suspense fallback={<div className="p-4">Loading...</div>}>
              <VectorDbPage />
            </Suspense>
          } />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}